import { FC, useCallback, useMemo } from 'react';
import PopUpContentWrapper from 'src/components/PopUpContentWrapper';
import MultiSelectBox from 'src/components/design-system/MultiSelectBox';
import PopUp from 'src/components/design-system/PopUp';
import { Department } from 'src/services/useGetDepartmentApi';
import { errorIcon, getBgColor } from 'src/utils/icons';

interface MultiSelectDepartmentProps {
  departmentList: Department[];
  selectedDepartments: Department[];
  setSelectedDepartments: (departments: Department[]) => void;
}

const MultiSelectDepartment: FC<MultiSelectDepartmentProps> = ({
  departmentList,
  selectedDepartments,
  setSelectedDepartments,
}) => {
  const preventDefault = useCallback((e: any) => {
    e.preventDefault();
  }, []);

  const { errorMessage, isMemberUpdateDisable } = useMemo(() => {
    const isMemberUpdateDisable = selectedDepartments.length === 0;
    let errorMessage: string[] = [];
    if (isMemberUpdateDisable) {
      errorMessage = ['Please select one or more Departments'];
    }
    return { isMemberUpdateDisable, errorMessage };
  }, [selectedDepartments.length]);

  return (
    <PopUp
      content={
        <div className="m-1 max-w-[300px]">
          <PopUpContentWrapper type="Error" contents={errorMessage} />
        </div>
      }
      show={isMemberUpdateDisable}
      popupAlign={{ horizontal: 'right', vertical: 'top' }}
    >
      <div className={` ${getBgColor(errorMessage)} text-[13px]`}>
        <p className="relative font-medium mb-2">
          <label className="w-full text-sm" htmlFor="search-input">
            Select Departments
          </label>
          {isMemberUpdateDisable && <span className="absolute ml-1">{errorIcon}</span>}
        </p>
        <div onDragStart={preventDefault} onDragOver={preventDefault}>
          <MultiSelectBox
            data={departmentList}
            value={selectedDepartments}
            setValue={setSelectedDepartments}
            dataItemKey="departmentId"
            textField="name"
          />
        </div>
      </div>
    </PopUp>
  );
};

export default MultiSelectDepartment;
